
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitopuneinnovacrystacab() {



    const cardData =
    {
        keyword: 'Mumbai to Pune Innova Crysta Cab  ',
        heading: 'Vedant Travels: Mumbai to Pune Innova Crysta Cab  ',
        headingDescription: 'Vedant Travels offers premium and comfortable Innova Crysta cabs for your journey from Mumbai to Pune. Whether you’re traveling for business or leisure, with family or friends, the Innova Crysta is the perfect choice for a spacious, comfortable, and luxurious ride. Our well-maintained fleet and professional drivers ensure a smooth, safe, and enjoyable travel experience.',

        top: 'Top Places to Visit in Pune with Vedant Travels',

       "topPlaces": [
        {
            "title": "Shaniwar Wada",
            "description": "A historic fort that was once the residence of the Peshwa rulers, Shaniwar Wada is a must-visit for history enthusiasts. The fort features impressive Maratha architecture and offers an engaging light-and-sound show that brings its fascinating history to life."
        },
        {
            "title": "Aga Khan Palace",
            "description": "Built in 1892, the Aga Khan Palace is not only a beautiful structure but also a significant historical site. It was used as a prison during the freedom struggle, and Mahatma Gandhi and his associates were held here. The palace is surrounded by lush gardens, providing a peaceful atmosphere for reflection."
        },
        {
            "title": "Sinhagad Fort",
            "description": "Located 35 km from Pune, Sinhagad Fort is a popular destination for trekkers and history lovers. The fort offers stunning views of the surrounding valleys and is known for its role in Maratha history. It’s a great place for those seeking adventure and historical exploration."
        },
        {
            "title": "Osho Ashram",
            "description": "Situated in Koregaon Park, the Osho Ashram is a globally recognized meditation and spiritual retreat center. Visitors can participate in a variety of meditation sessions and spiritual workshops, making it an ideal spot for relaxation and inner peace."
        },
        {
            "title": "Raja Dinkar Kelkar Museum",
            "description": "The Raja Dinkar Kelkar Museum houses a vast collection of Indian artifacts, including sculptures, musical instruments, and daily-use items from different historical periods. It’s a fascinating stop for anyone interested in India’s cultural heritage."
        },
        {
            "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
            "description": "A beautiful Japanese-inspired garden located in Pune, this garden is perfect for a relaxing stroll. With lush greenery, vibrant flowers, and serene ponds, it offers a peaceful escape from the busy city life."
        },
        {
            "title": "Pashan Lake",
            "description": "Pashan Lake is a serene spot, perfect for nature lovers and birdwatching enthusiasts. Surrounded by lush greenery, it provides a quiet environment for photography, walks, and peaceful reflection."
        },
        {
            "title": "Bund Garden",
            "description": "Bund Garden is a riverside park ideal for a relaxing walk, boating, or picnicking. The tranquil atmosphere and natural beauty make it a lovely spot to unwind and enjoy time with family or friends."
        },
        {
            "title": "Saras Baug",
            "description": "Saras Baug is a popular temple complex in Pune, known for its beautiful Ganesha temple and peaceful gardens. It’s a great place to enjoy a leisurely walk, relax in the gardens, or simply seek spiritual solace."
        },
        {
            "title": "Fergusson College",
            "description": "One of Pune’s oldest and most prestigious educational institutions, Fergusson College is known for its colonial-era architecture and rich academic history. It’s a beautiful campus to explore, showcasing Pune’s educational legacy and architectural beauty."
        }
    ],
    "services": [
        {
            "name": "Mumbai to Pune Innova Crysta Cab Booking",
            "description": "For a comfortable and luxurious ride from Mumbai to Pune, book your Innova Crysta cab with Vedant Travels. Our fleet of well-maintained vehicles ensures a smooth and enjoyable journey, perfect for family or group travel."
        },
        {
            "name": "Mumbai Airport to Pune Innova",
            "description": "Traveling from Mumbai Airport to Pune? Choose our Innova Crysta for a comfortable and spacious ride. With professional drivers and high-quality vehicles, your journey will be smooth and stress-free."
        },
        {
            "name": "Pune to Mumbai Airport One Way Innova Cab",
            "description": "Need a one-way trip from Pune to Mumbai Airport? Book our Innova Crysta for a premium experience. Our taxi service ensures punctuality and comfort for your airport transfer."
        },
        {
            "name": "Mumbai Airport to Koregaon Innova Cab",
            "description": "For a trip from Mumbai Airport to Koregaon, our Innova Crysta taxis offer the perfect combination of comfort, space, and luxury. Enjoy a hassle-free journey with personalized services and competitive pricing."
        },
        {
            "name": "Mumbai Airport to Viman Nagar Innova Cab",
            "description": "Need a ride from Mumbai Airport to Viman Nagar? Choose our Innova Crysta for a comfortable and safe transfer. With ample space for your luggage and a professional driver, enjoy a stress-free ride to your destination."
        },
        {
            "name": "Mumbai Airport to Kothrud Innova Car Fare",
            "description": "Traveling from Mumbai Airport to Kothrud? Our Innova Crysta taxis offer a comfortable and efficient journey. The fare is competitive, and we guarantee a safe, smooth ride with a professional driver."
        },
        {
            "name": "Mumbai Airport to Pune Station Innova Cab",
            "description": "For a ride from Mumbai Airport to Pune Station, choose our Innova Crysta for luxury and comfort. Our taxi service provides timely transfers with experienced drivers to ensure you reach your destination on time."
        },
        {
            "name": "Innova Crysta on Rent Mumbai Airport",
            "description": "Looking for an Innova Crysta rental from Mumbai Airport? Vedant Travels offers premium car rental services, perfect for travelers seeking comfort and space. Rent an Innova Crysta with us for a luxurious and hassle-free experience."
        }
    ],

    "tableData": [
        ["Mumbai to Pune Innova Crysta Cab Booking", "Mumbai Airport to Pune Innova"],
        ["Pune to Mumbai Airport One Way Innova Cab", "Mumbai Airport to Koregaon Innova Cab"],
        ["Mumbai Airport to Viman Nagar Innova Cab", "Mumbai Airport to Kothrud Innova Car Fare"],
        ["Mumbai Airport to Pune Station Innova Cab", "Innova Crysta on Rent Mumbai Airport"]
      ],
      "whychoose": [
        {
          "WhyChooseheading": "Reliable and On-Time Service",
          "WhyChoosedescription": "At Vedant Travels, we prioritize punctuality, especially for long-distance journeys like Mumbai to Pune. Whether you’re traveling for business, a family vacation, or a personal trip, our professional drivers ensure timely pickups and smooth travel, so you can focus on enjoying your journey."
        },
        {
          "WhyChooseheading": "Comfortable and Spacious Innova Crysta",
          "WhyChoosedescription": "Our Innova Crysta cabs are perfect for long-distance travel from Mumbai to Pune. The spacious and luxurious interiors are designed for maximum comfort, with plenty of legroom and comfortable seating for all passengers. With air conditioning, premium seating, and a smooth ride, your journey will be both relaxing and enjoyable."
        },
        {
          "WhyChooseheading": "Experienced and Professional Drivers",
          "WhyChoosedescription": "Our drivers are skilled in navigating the Mumbai to Pune route, ensuring a safe and smooth ride. They are highly trained to handle long-distance travel, traffic conditions, and any challenges that may arise on the way. You can rely on their professionalism and local knowledge for a stress-free experience."
        },
        {
          "WhyChooseheading": "Affordable and Transparent Pricing",
          "WhyChoosedescription": "We offer competitive pricing for our Mumbai to Pune Innova Crysta Cab service. There are no hidden fees or surprises—just clear and upfront pricing so you can plan your trip without any stress. Enjoy the comfort and luxury of the Innova Crysta without breaking the bank."
        },
        {
          "WhyChooseheading": "Safe and Comfortable Journey",
          "WhyChoosedescription": "Your safety is our number one concern. All our Innova Crysta vehicles are well-maintained and equipped with advanced safety features, including airbags, seat belts, GPS tracking, and more. Our drivers adhere to strict safety protocols, ensuring a safe and comfortable journey from Mumbai to Pune."
        },
        {
          "WhyChooseheading": "24/7 Availability",
          "WhyChoosedescription": "Whether you're traveling early in the morning or late at night, Vedant Travels is available for your Mumbai to Pune Innova Crysta Cab needs. Our customer service team is available round the clock to help you book your ride and address any concerns you may have."
        },
        {
          "WhyChooseheading": "Hassle-Free Booking Process",
          "WhyChoosedescription": "Booking your Mumbai to Pune Innova Crysta Cab with Vedant Travels is quick and easy. You can book online through our website or mobile app, or simply contact our customer service team for assistance. We strive to make your booking experience as smooth as possible."
        },
        {
          "WhyChooseheading": "Customizable Travel Packages",
          "WhyChoosedescription": "Whether you're traveling for business or leisure, we offer customizable travel packages for your Mumbai to Pune trip. Let us know your specific requirements, and we’ll tailor the Innova Crysta experience to meet your needs, including sightseeing stops and other special requests."
        }
      ]

    }



    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Pune Innova Crysta cab with Vedant Travels?',
            answer: 'You can easily book an Innova Crysta Cab from Mumbai to Pune through our website or mobile app. Alternatively, our customer service team is available to assist with booking your ride.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and specifically in navigating the Mumbai to Pune route. They ensure a smooth and safe journey, offering the best experience for you.',
        },
        {
            id: 3,
            question: 'What is the seating capacity of the Innova Crysta?',
            answer: 'The Innova Crysta can comfortably seat up to 7 passengers, making it an ideal choice for families or small groups traveling from Mumbai to Pune.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Pune Innova Crysta cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments through our app, making it easy and convenient for you to pay for your ride.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip Innova Crysta from Mumbai to Pune?',
            answer: 'Yes, you can book a round-trip Innova Crysta cab for your Mumbai to Pune journey. Simply provide us with your return details during the booking process, and we will handle the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any extra charges for waiting or detours will be clearly communicated to you upfront. We believe in transparency, so you won’t encounter any hidden fees.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing during my Mumbai to Pune trip?',
            answer: 'Yes, we offer customizable sightseeing options during your Mumbai to Pune journey. You can explore iconic spots along the way or once you reach Pune, with the comfort of your Innova Crysta.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for an Innova Crysta?',
            answer: 'The Innova Crysta has ample space for standard luggage. If you have special requirements or excess luggage, please inform us while booking, and we will make arrangements accordingly.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel from Mumbai to Pune?',
            answer: 'Yes, we offer corporate travel services with Innova Crysta cabs for business trips. Whether it\'s for meetings, conferences, or team travel, we can customize the experience to suit your company\'s needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for my Mumbai to Pune Innova Crysta trip?',
            answer: 'Vedant Travels is known for its reliable service, professional drivers, competitive pricing, and luxurious Innova Crysta vehicles. We ensure a comfortable, safe, and hassle-free journey, making us the best choice for your Mumbai to Pune travel needs.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rajesh Sharma",
            title: "Family Traveler",
            quote: "I had an amazing experience traveling from Mumbai to Pune in an Innova Crysta with Vedant Travels. The car was incredibly comfortable, and the driver was very professional. It was the perfect ride for my family, and we’ll definitely use their service again!",
            rating: 5,
        },
        {
            name: "Ms. Priya Desai",
            title: "Business Traveler",
            quote: "I booked an Innova Crysta for a business trip from Mumbai to Pune, and it was an excellent choice. The vehicle was spacious, well-maintained, and the driver was on time. I had a very comfortable and productive journey.",
            rating: 5,
        },
    ];
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Innova Crysta Cab Service",
  "image": "https://vedanttravels.in/assets/images/mumbai-to-pune-innova-crysta-cab-service.jpg",
  "description": "Book Mumbai to Pune Innova Crysta cab service with Vedant Travels for a spacious, comfortable, and safe ride. Ideal for families and groups, available for one-way, round-trip, and airport transfers with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-to-pune-innova-crysta-cab-service"
  }
};



      
     
      


    return (
        <div>
           
         <Helmet>
  <title>Mumbai to Pune Innova Crysta Cab Service | Spacious & Comfortable | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune Innova Crysta cab service with Vedant Travels for a spacious, comfortable, and safe ride. Ideal for families and groups, available for one-way, round-trip, and airport transfers with experienced drivers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune Innova Crysta Cab Service, Innova Crysta Taxi Mumbai Pune, Mumbai to Pune Group Cab, Family Cab Mumbai Pune, AC Innova Crysta Cab Mumbai Pune, One-Way Innova Crysta Cab Mumbai Pune, Round Trip Innova Crysta Cab Mumbai Pune, Vedant Travels Mumbai Pune, Online Cab Booking Mumbai Pune, Comfortable Innova Crysta Ride, Spacious Taxi Mumbai Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/56.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopuneinnovacrystacab;